import { placesQueryKeys as e } from "./usePlacesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { placesApi as n } from "@maat/api-main";
//#region src/places/useReverseGeocodeQuery.ts
var r = (r) => t({
	queryKey: e.reverse(r?.latitude ?? 0, r?.longitude ?? 0),
	queryFn: () => n.reverseGeocode(r.latitude, r.longitude),
	enabled: !!r,
	retry: !1
});
//#endregion
export { r as useReverseGeocodeQuery };
